import { ref, watch } from 'vue';

const STORAGE_KEY = 'punchlog_app_config';
const DEFAULTS = { autosaveTimesheet: true, autoSignEnabled: false };

function load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? { ...DEFAULTS, ...JSON.parse(raw) } : { ...DEFAULTS };
  } catch {
    return { ...DEFAULTS };
  }
}

// Singleton config ref shared across all callers
const config = ref(load());

watch(
  config,
  val => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(val));
    } catch {
      /* ignore */
    }
  },
  { deep: true },
);

export function useAppConfig() {
  return { config };
}
